module.exports = __webpack_public_path__ + "static/media/bathroom-re-fit_04.8f85d816.png";